import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'filter'})
export class FilterPipe implements PipeTransform {
  transform(value: { [propName: string]: any }[], property: string): any {
    return value.filter(v => !v[property]);
  }
}
